import React from "react"
import cx from "classnames";
import styles from "./CardList.module.css";
import Image from "next/image";
import LazyLoad from "react-lazy-load";
import Skeleton from "@mui/material/Skeleton";
import Link from "next/link";

const Skelet = (
    <Skeleton
        className={cx(styles.mainSkeletonStyles)}
        variant="rectangular"
        height={"100%"}
        width={"100%"}
    />
);
const CardList = ({id, link, img, imgAlt, title, cat, date, dark, slug, duration}) => {
    return (
        <Link
            href={link}
            style={{gap: "0"}}
            className={cx(
                styles.container,
                dark && styles.containerDark,
                !dark && styles.containerLight,
                "d-flex",
                "flex-column",
                "align-items-start",
                "justify-content-start"
            )}
        >
            <LazyLoad className="w-100" offset={200}>
                <div
                    className={cx(
                        styles.imgWrapper,
                        "d-flex",
                        "align-items-center",
                        "w-100",
                        "position-relative",
                        "justify-content-center",
                        "position-relative"
                    )}
                >
                    {duration && (<span
                        className={cx(
                            styles.videoDurationStyles,
                            "d-flex",
                            "align-items-center",
                            "justify-content-center",
                            "position-absolute"
                        )}
                    >{duration}</span>)}
                    {img ? (
                        <Image
                            style={{borderRadius: dark ? "8px 8px 0 0" : "8px"}}
                            src={img}
                            alt={imgAlt ? imgAlt : title}
                            className={cx(styles.imgStyles, "w-100", "h-100")}
                            unoptimized={true}
                            width="100"
                            height="100"
                        />
                    ) : (
                        Skelet
                    )}
                </div>
            </LazyLoad>
            {!dark && (
                <div
                    style={{gap: "0", padding: "20px 0"}}
                    className="h-100 d-flex flex-column align-items-start justify-content-start"
                >
          <span
              className={cx("d-lg-flex", "d-none", styles.dateStyles, "mb-2")}
          >
            {cat}
          </span>
                    <h2
                        className={cx(styles.titleStyles, "mb-auto", styles.tagmargin)}
                    >
                        {title}
                    </h2>
                    <div
                        className={cx(
                            styles.dateContainer,
                            "d-none",
                            "d-lg-flex",
                            "align-items-center",
                            "justify-content-start",
                            "w-100"
                        )}
                    >
                        <span className={cx(styles.dateStyles)}>{date}</span>
                    </div>
                    <div className="d-flex d-lg-none align-items-center justify-content-start">
                        <span className={cx(styles.dateStyles)}>{cat}</span>
                        <span className={cx(styles.verticalLline)}></span>
                        <div
                            className={cx(
                                styles.dateContainer,
                                "d-lg-none",
                                "d-flex",
                                "align-items-center",
                                "justify-content-start",
                                "w-100"
                            )}
                        >
              <span className={cx(styles.dateStyles)}>
                {date}
              </span>
                        </div>
                    </div>
                </div>
            )}
            {dark && (
                <div
                    style={{ gap: "0", padding: "20px" }}
                    className="h-100 w-100 d-flex flex-column align-items-start justify-content-start"
                >
                    <span className={cx(styles.dateStyles)}>{cat}</span>
                    <h2
                        className={cx(
                            styles.titleStylesDark,
                            "mb-auto",
                            styles.marginTop20px
                        )}
                    >
                        {title}
                    </h2>
                    <div
                        className={cx(
                            styles.dateContainer,
                            "d-flex",
                            "align-items-center",
                            "justify-content-start",
                            "w-100"
                        )}
                    >
                        <span className={cx(styles.dateStyles)}>{date}</span>
                    </div>
                </div>
            )}
        </Link>
    )
}

export default CardList